var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-text',{attrs:{"value":_vm.displayValue,"label":_vm.label ?? 'Documento Federal',"maxlength":18,"allowSpecialChars":"","error-messages":_vm.erroDocumento ? ['Documento inválido'] : [],"hide-details":_vm.hideDetails},nativeOn:{"input":function($event){return _vm.handleInput.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }